// Reading what the tools keep, for the admin home's morning summary and the weekly summary.
// Each source is read on its own, so one that fails is named while the rest still show.

export async function getJson(url) {
  const response = await fetch(url, { credentials: "include", cache: "no-store" });
  if (!response.ok) throw new Error(`${url} returned ${response.status}`);
  return response.json();
}

export const asList = (value) => (Array.isArray(value) ? value : []);

// Each firm's part of one source. The source counts as loaded if any firm's part did.
export async function perFirm(brands, load) {
  const results = await Promise.allSettled(brands.map(load));
  if (results.every((result) => result.status === "rejected")) throw results[0].reason;
  return Object.fromEntries(brands.map((brand, index) => [brand, results[index].status === "fulfilled" ? results[index].value : []]));
}

// Shared records in vals_drafts, and per-person ones in portal_drafts, of one form type.
export const sharedDrafts = (brand, formType) =>
  getJson(`/api/vals-drafts?${new URLSearchParams({ brand, form_type: formType })}`).then(asList);
export const portalDrafts = (brand, formType) =>
  getJson(`/api/portal-drafts?${new URLSearchParams({ form_type: formType, brand })}`).then(asList);

// Every source at once: { key: value } for those that loaded. One that could not be read is
// left out, and the summaries say so.
export async function loadSources(sources, label) {
  const keys = Object.keys(sources);
  const results = await Promise.allSettled(keys.map((key) => sources[key]()));
  const data = {};
  results.forEach((result, index) => {
    if (result.status === "fulfilled") data[keys[index]] = result.value;
    else console.warn(`${label}: ${keys[index]} could not be read:`, result.reason);
  });
  return data;
}
